module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-table', {
    attrs: {
      "editPath": "/main/course/group/schedule/edit",
      "data-api": this.api.coach.course,
      "params": _vm.params,
      "deletable": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "courseName",
      "label": "课程名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "上课时间",
      "formatter": _vm.timeFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reservation",
      "label": "预约人数",
      "formatter": function(row) {
        return row.reserve + '/' + row.personMax
      }
    }
  }, [_vm._v("\"}\">\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08cf9409","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/coach/view/course.vue
// module id = 1103
// module chunks = 2